import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { useTheme } from '../../hooks/useTheme.js';
import { Stack } from '../../Stack/Stack.js';
import { Text } from '../../Text/Text.js';
import { Box } from '../../Box/index.js';

var AlertContent = function (_a) {
    var title = _a.title, children = _a.children, sx = _a.sx, props = __rest(_a, ["title", "children", "sx"]);
    var mergeStyles = useTheme().mergeStyles;
    return (jsx(Box, __assign({ sx: mergeStyles([{ py: 1 }, sx]) }, { children: jsxs(Stack, __assign({ gap: 4 }, props, { children: [title && (jsx(Text, __assign({ crop: true, sx: { pr: "1.2em" } }, { children: jsx("strong", { children: title }) }))), jsx(Text, __assign({ crop: true }, { children: children }))] })) })));
};
AlertContent.displayName = "AlertContent";

export { AlertContent };
//# sourceMappingURL=index.js.map
